import indexTableEventListeners from './index-table-event-listeners'

$(document).on('turbolinks:load', function () {
    indexTableEventListeners()
    }
)
